import * as React from 'react';

const TariffsTablet = ({ width, height }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    fill='none'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7 1.5H13C13.8284 1.5 14.5 2.17157 14.5 3V17C14.5 17.8284 13.8284 18.5 13 18.5H7C6.17157 18.5 5.5 17.8284 5.5 17V3C5.5 2.17157 6.17157 1.5 7 1.5ZM4.09451 2.25C4.42755 0.95608 5.60212 0 7 0H13C14.3979 0 15.5725 0.95608 15.9055 2.25H16C18.0711 2.25 19.75 3.92893 19.75 6V14C19.75 16.0711 18.0711 17.75 16 17.75H15.9055C15.5725 19.0439 14.3979 20 13 20H7C5.60212 20 4.42755 19.0439 4.09451 17.75H4C1.92893 17.75 0.25 16.0711 0.25 14V6C0.25 3.92893 1.92893 2.25 4 2.25H4.09451ZM4 3.75C2.75736 3.75 1.75 4.75736 1.75 6V14C1.75 15.2426 2.75736 16.25 4 16.25V3.75ZM16 16.25C17.2426 16.25 18.25 15.2426 18.25 14V6C18.25 4.75736 17.2426 3.75 16 3.75V16.25Z'
      fill='#333333'
    />
  </svg>
);

export default TariffsTablet;
